import React from 'react';
import './styles.scss';

const Notice = () => {
  return (
    <div className='max-w-[998px] mt-8 rounded-[10px] border-[4px] border-[#222426] bg-white px-4 md:px-[50px] pt-4 md:pt-[50px] pb-5 md:pb-[60px] mx-auto notice'>
      <div className='flex justify-center items-center notice_heading'>
        <p className='text-[20px] md:text-[28px]'>NOTICE BOARD</p>
        <div className='absolute bg-[#222426] w-[13.6px] h-[13.6px] top-[-10px] left-[-10px]'></div>
        <div className='absolute bg-[#222426] w-[13.6px] h-[13.6px] top-[-10px] right-[-10px]'></div>
        <div className='absolute bg-[#222426] w-[13.6px] h-[13.6px] bottom-[-10px] left-[-10px]'></div>
        <div className='absolute bg-[#222426] w-[13.6px] h-[13.6px] bottom-[-10px] right-[-10px]'></div>
      </div>
      <div className='notice_body'>
        <p className='text-[16px] md:text-[22px]'>
          Et porttitor ut arcu magna convallis sed erat. Neque mattis arcu elit turpis convallis
          bibendum lacus elementum. Eget id egestas elit ipsum felis sed faucibus malesuada pretium.
          Turpis sit in ac magnis ultricies vitae vitae. Maecenas egestas tortor tristique sem id
          consequat. Sit ut sem massa lectus adipiscing vel fermentum viverra. Varius et scelerisque
          netus mi nisl. Cursus turpis magna semper ut morbi duis arcu facilisis.
        </p>
      </div>
    </div>
  );
};

export default Notice;
